// ─── src/hooks/useTheme.js ────────────────────────────────────────────────────
//
// Custom hook that fetches the saved color theme from Firestore on mount
// and injects each CSS custom property into document.documentElement.style.
//
// Inline styles on :root always override stylesheet :root{} rules,
// so this works without touching index.css at all.
//
// Usage — call once at the top of your App.jsx or main layout:
//
//   import { useTheme } from './hooks/useTheme';
//   export default function App() {
//     useTheme();   // ← just this one line
//     return ( ... );
//   }

import { useEffect } from 'react';
import { fetchTheme } from '../components/data';

export function useTheme() {
  useEffect(() => {
    let cancelled = false;

    fetchTheme()
      .then(theme => {
        if (cancelled || !theme) return;
        const root = document.documentElement.style;
        Object.entries(theme).forEach(([varName, hex]) => {
          if (hex) root.setProperty(varName, hex);
        });
      })
      .catch(err => {
        // Non-fatal: CSS file defaults will be used
        console.warn('[useTheme] Could not load theme from Firestore:', err.message);
      });

    return () => { cancelled = true; };
  }, []);
}